import { COUNTABLE_SCREENS } from '@sharedConstants';
import { configureStore } from '@reduxjs/toolkit';
import userColorTheme from '@content/color-theme.json';
import routeReducer, { initialRouteState } from './slices/routeSlice';
import gameStateReducer, { initialGameState } from './slices/gameStateSlice';
import themeReducer, { initialThemeState } from './slices/themeSlice';
import loggingReducers, { initialLoggingState } from './slices/loggingSlice';
import levellingReducer, {
  initialLevellingState,
} from './slices/levellingSlice';
import loggingMiddleware from './middleware/loggingMiddleware';

const loadedLoggingMiddleware = loggingMiddleware();

const store = ({ allRoutes = [], pooledRoutes = [] } = {}) =>
  configureStore({
    preloadedState: {
      route: {
        ...initialRouteState,
        // these are loaded at gatsby build time, but allRoutes will change when app inits based on game config
        allRoutes,
        pooledRoutes,
        allOriginalRoutes: allRoutes,
      },
      gameState: {
        ...initialGameState,
      },
      levelling: {
        ...initialLevellingState,
        // from our routes, count the number of claims
        totalClaims: allRoutes.filter(e =>
          COUNTABLE_SCREENS.includes(e.typeOfScreen),
        ).length,
      },
      logging: {
        ...initialLoggingState,
      },
      theme: {
        ...initialThemeState,
        // TODO: eventually could let user define more things here
        colors: userColorTheme,
      },
    },
    reducer: {
      route: routeReducer,
      gameState: gameStateReducer,
      levelling: levellingReducer,
      logging: loggingReducers,
      theme: themeReducer,
    },
    middleware: getDefaultMiddleware => {
      // ignore middleware for tests
      if (process.env.NODE_ENV === 'test') {
        return getDefaultMiddleware();
      }
      return getDefaultMiddleware().concat([loadedLoggingMiddleware]);
    },
  });
const dummyStore = store();
export type RootState = ReturnType<typeof dummyStore.getState>;
export type AppDispatch = typeof dummyStore.dispatch;

export default store;
